











import JSZip, { JSZipObject } from 'jszip';
import NxFileUploader from '@/modules/upload/FileUploader.vue';
import { mimeTypeMatch } from '@/utils';
import mimeTypes from 'mime-types';

export type UncompressedImage = {
  name: string;
  blobUrl: string;
  extension: string;
  file: File;
  state: 'PROCESSING'|'PENDING'|'SUCCESS'|'FAILED';
  draft?: object,
};
/**
 * @emits input --> UncompressedImage[]
 * @emits start
 * @emits end
 */
export default {
  name: 'nx-zip-selector',
  components: {
    NxFileUploader,
  },
  props: {
    disabled: {
      type: Boolean,
    },
    allowedMimes: {
      type: String,
    },
  },
  data() {
    return {
      selectedFileName: '',
    };
  },
  methods: {
    dismiss() {},
    async onFileSelected(file: File) {
      this.selectedFileName = file.name;
      const files = await this.unzip(file);
      this.$emit('input', files);
    },
    async unzip(file: File): Promise<UncompressedImage[]> {
      this.$emit('start');
      const zip: JSZip = await JSZip.loadAsync(file);
      const fileImages: JSZipObject[] = await zip.file(/^(?!\.|__).*$/i);
      const images: UncompressedImage[] = [];
      // eslint-disable-next-line
      for await (const image of fileImages) {
        const name: string = image.name.replace(/^.*[\\/]/, '');
        const extension = name.split('.').pop()!;
        const mimeType = mimeTypes.lookup(extension);
        if (this.allowedMimes && !mimeTypeMatch(mimeType, this.allowedMimes)) {
          console.log('File not accepted in ZipSelector', image);
          // eslint-disable-next-line no-continue
          continue;
        }
        const blob: Blob = await image.async('blob');
        const blobUrl = window.URL.createObjectURL(blob);
        const fileImage = new File([blob], name, { type: `image/${extension}` });
        const uncompressedImage: UncompressedImage = {
          extension,
          file: fileImage,
          name,
          blobUrl,
          state: 'PENDING',
        };
        images.push(uncompressedImage);
      }
      this.$emit('end');
      return images;
    },
  },
};
